<template>
  <div>
    <v-btn v-if="icon" @click="selectFile" color="accent" icon><v-icon>mdi-upload</v-icon></v-btn>
    <v-btn v-if="!icon" @click="selectFile" :class="'inset'" color="primary">Upload image</v-btn>
    <input :ref="`input-${inputKey}`" :id="inputKey" @change="setImage" type="file" name="image" accept="image/*">
    <v-dialog scrollable width="700" v-model="openModal">
      <v-card>
        <v-card-title class="headline">Image Upload</v-card-title>
        <v-card-text>
          <vue-cropper
            :ref="`cropper-${inputKey}`"
            :src="this.src"
            :viewMode="1"
            :containerStyle="containerStyle"
            :zoomable="false"
          >
          </vue-cropper>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">Close</v-btn>
          <v-btn text @click="save" color="primary">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'ImageCropper',
  props: ['src', 'icon', 'input-key'],
  components: {
    VueCropper
  },
  data () {
    return {
      openModal: false,
      type: null,
      croppedImg: null,
      containerStyle: {
        width: '100%',
        'max-height': '450px'
      }
    }
  },
  methods: {
    cropImage () {
      if (this.$refs[`cropper-${this.inputKey}`]) {
        this.croppedImg = this.$refs[`cropper-${this.inputKey}`].getCroppedCanvas().toDataURL(this.type)
      }
    },

    async save () {
      // upload
      this.cropImage()
      // let res = await this.$store.dispatch('uploadPicture', this.croppedImg)
      this.$emit('image-selected', this.croppedImg)
      this.close()
    },

    close () {
      this.openModal = false
    },

    setImage (e) {
      const file = e.target.files[0]
      if (!file) {
        return
      }
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        return
      }
      this.type = file.type
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          this.openModal = true
          setTimeout(() => {
            this.$refs[`cropper-${this.inputKey}`].replace(event.target.result)
          }, 200)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },

    selectFile () {
      const input = document.getElementById(this.inputKey)

      input.click()
    }
  }
}
</script>

<style lang="sass" scoped>

input
  display: none

</style>
